import {
  Dialog,
  DialogClose,
  DialogContent,
  DialogFooter,
  DialogHeader,
} from "@/components/ui/dialog";
import { AdminPageProps, Product } from "@/types";
import { DialogTitle } from "@radix-ui/react-dialog";
import { Button } from "@/components/ui/button";
import { useForm, usePage } from "@inertiajs/react";
import { Field, FieldLabel } from "@/components/ui/field";
import { Input } from "@/components/ui/input";
import { Spinner } from "@/components/ui/spinner";
import { FormEvent } from "react";
import { restock_store_product_path } from "@/lib/routes";
import { DialogProps } from "@/types/ui";
import useTranslations from "@/hooks/use-translations";

export default function RestockProductDialog({
  product,
  open,
  onOpenChange,
}: {
  product: Product;
} & DialogProps) {
  const { current_store } = usePage<AdminPageProps>().props;
  const { t } = useTranslations("shared.components.restock_product_dialog");
  const restockProductForm = useForm({ quantity: 1 });

  function onSubmit(event: FormEvent) {
    event.preventDefault();

    restockProductForm.patch(
      restock_store_product_path(current_store!.id, product.id),
      {
        invalidateCacheTags: ["stores", current_store!.id ?? ""],
        onSuccess() {
          restockProductForm.resetAndClearErrors();
          onOpenChange(false);
        },
      }
    );
  }

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>{t("title")}</DialogTitle>
        </DialogHeader>

        <form
          id={`restock-product-form-${product.id}`}
          onSubmit={onSubmit}
          className="flex-1 flex flex-col gap-5"
        >
          <Field>
            <FieldLabel htmlFor="quantity">{t("shared.fields.quantity")}</FieldLabel>
            <Input
              id="quantity"
              name="product[quantity]"
              type="number"
              step="1"
              placeholder={t("shared.fields.quantity_placeholder")}
              value={restockProductForm.data.quantity}
              onChange={(e) =>
                restockProductForm.setData("quantity", e.target.valueAsNumber)
              }
            />
          </Field>
        </form>

        <DialogFooter>
          <DialogClose asChild>
            <Button variant="outline" disabled={restockProductForm.processing}>
              {t("shared.actions.cancel")}
            </Button>
          </DialogClose>
          <Button
            type="submit"
            form={`restock-product-form-${product.id}`}
            disabled={restockProductForm.processing}
          >
            {restockProductForm.processing && <Spinner />}
            {t("submit")}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
